import * as React from "react";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { SkillSuggestion } from "../../../models/skills";
import { ExperienceSkill } from "../../../models/profile";
import { LookupValue } from "../../../models/lookup";
import { ScreenMode, LookupType } from "../../../models/enums";
import { Grid, Row, Col } from "react-flexbox-grid";
import Select from "material-ui/Select"
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormControlLabel } from "material-ui/Form";
import { InputLabel } from "material-ui/Input";
import ArrowButton from "material-ui-icons/ArrowBack";
import ExpansionPanel, { ExpansionPanelDetails, ExpansionPanelSummary, ExpansionPanelActions } from "material-ui/ExpansionPanel";
import Typography from "material-ui/Typography";
import Paper from "material-ui/Paper";
import ExpandMoreIcon from "material-ui-icons/ExpandMore";
import * as s from "./skill.css";

@observer
export default class SkillPicker extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  renderExpansionPanel(s: SkillSuggestion): JSX.Element {
    const styles = {
      MuiIconButton: {
        color: "#EA7600",
      },
      expansionPanel: {
        boxShadow: "none",
        backgroundColor: "#F6F8F8",
      },
      expansionSummary: {
        paddingLeft: "16px",
      },
      expansionDetails: {
        display: "block",
      }
    };
    return <ExpansionPanel style={styles.expansionPanel}>
      <ExpansionPanelSummary style={styles.expansionSummary} expandIcon={<ExpandMoreIcon style={styles.MuiIconButton} />}>
        <div>{s.title}</div>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails style={styles.expansionDetails}>
        <div style={{ fontSize: "0.75em" }} dangerouslySetInnerHTML={{ __html: s.description }}></div>
      </ExpansionPanelDetails>
    </ExpansionPanel>;

  }
  render(): JSX.Element {
    const paper: any = { backgroundColor: "#F6F8F8" };
    const suggestions: Array<SkillSuggestion> = this.props.store.profileStore.suggestedSkills;
    if (!suggestions || suggestions.length === 0) {
      return null;
    }
    const usage: JSX.Element[] = [];
    this.props.store.localization.getLookup(LookupType.UseFrequency).map((lv: LookupValue, i: number): void => {
      usage.push(<MenuItem key={i} value={lv.order}>{lv.value}</MenuItem>);
    });
    const col1: JSX.Element[] = [];
    const col2: JSX.Element[] = [];
    let c1Start: number = 0;
    let c1End: number = this.props.store.viewState.screenMode === ScreenMode.Mobile ? suggestions.length : Math.ceil(suggestions.length / 2);
    col1.push(<Row key="c1-hdr" className={s.colHeadings}>
      <Col xs={8}><u>{this.props.store.localization.fields.skillLabel}</u></Col>
      <Col xs={3}><u>{this.props.store.localization.fields.usage}</u></Col>
    </Row>);
    if (c1End < suggestions.length) {
      col2.push(<Row key="c2-hdr" className={s.colHeadings}><Col xs={8}><u>{this.props.store.localization.fields.skillLabel}</u></Col><Col xs={3}><u>{this.props.store.localization.fields.usage}</u></Col></Row>);
    }
    suggestions.map((s: SkillSuggestion, i: number): void => {
      const es: ExperienceSkill = this.props.store.profileStore.getSkillExperience(s.id);
      if (!es) { return; }
      if (i >= c1Start && i < c1End) {
        col1.push(<Row key={i}>
          <Col xs={8}>{this.renderExpansionPanel(s)}</Col>
          <Col xs={3}>
            <FormControl fullWidth>
              <Select value={es.used} onChange={(e: any) => this.props.store.profileStore.setSkillUsage(s.id, e.target.value)}>
                {usage}
              </Select>
            </FormControl>
          </Col>
        </Row>);
      } else {
        col2.push(<Row key={i}>
          <Col xs={8}>{this.renderExpansionPanel(s)}</Col>
          <Col xs={3}>
            <FormControl fullWidth>
              <Select value={es.used} onChange={(e: any) => this.props.store.profileStore.setSkillUsage(s.id, e.target.value)}>
                {usage}
              </Select>
            </FormControl>
          </Col>
        </Row>);
      }
    });
 
    return <div>
      <Paper elevation={4} className={s.paper} style={paper} >
      <h6 className={s.header}>{this.props.store.localization.fields.suggestedSkills}</h6>
      <div className={s.subHeading}>{this.props.store.localization.fields.suggestedSkillText}</div>
      <br />
      {col2.length === 0 && <div>
        <Row className={s.row}>
          <Col xs={12} sm={12}>{col1}</Col>
        </Row>
      </div>}
      {col2.length > 0 && <div>
        <Row className={s.row}>
          <Col xs={12} sm={6}>{col1}</Col>
          <Col xs={12} sm={6}>{col2}</Col>
        </Row>
      </div>}
      </Paper>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/skillSuggestions/index.tsx